import { Icon } from '@pata-app/icons';

import React, { useEffect, useState } from 'react';

import { LoadingIndicatorContainer } from './loadingIndicator.styled';

interface ILoadingIndicator {
  message?: string;
}

const LoadingIndicator = ({ message = 'Loading...' }: ILoadingIndicator) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(true);
    }, 300);
  }, []);

  return (
    <LoadingIndicatorContainer>
      {showLoader && (
        <>
          <Icon type="PataLoader" size="300px" />
          <span> {message}</span>
        </>
      )}
    </LoadingIndicatorContainer>
  );
};

export default LoadingIndicator;
